export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/soroush-karimi-29df8117c07250e9b1ea8e3a67627f67.jpg";